import { render } from "./FeaturedProducts.vue?vue&type=template&id=06f1ad88&scoped=true"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js"

import "./FeaturedProducts.vue?vue&type=style&index=0&id=06f1ad88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f1ad88"]])

export default __exports__